import { createContext, useState, useContext, useEffect } from "react";

export const CartContext = createContext();

export const CartContextProvider = ({ children }) => {

    const [cart, setCart] = useState([]);
    const [wishList, setWishList] = useState([]);
    const [openCart, setOpenCart] = useState(false);

    const toggleCart = () => {
        setOpenCart((st) => !st);
    }



    const saveToCart = async (data) => {
        try {
            const cartData = localStorage.getItem("cart_data");
            /** create new cart and add data */
            if (!cartData) {
                const newCart = JSON.stringify([data]);      
                setCart([data]);
                localStorage.setItem('cart_data', newCart);
            } else {
                /** Or add data to existing cart */
                const listArray = JSON.parse(cartData);
                const inCart = listArray.some((obj) => obj?._id === data?._id);
                /** remove cart data */
                if (inCart) {
                    setCart(() => cart.filter((obj) => obj?._id !== data?._id));
                    const reducedCart = listArray?.filter((obj) => obj?._id !== data?._id);
                    localStorage.setItem('cart_data', JSON.stringify(reducedCart));
                    return;
                }
                setCart((oldCart) => ([...oldCart, data]));
                localStorage.setItem("cart_data", JSON.stringify([...listArray, data]));
            }

        } catch (error) {
            console.log({ error });
        }
    }

    const saveToWishList = (itemData) => {
        //read from localstorage
        const data = localStorage.getItem('wish_list');

        //no wishlist data e.g. in first use case
        if (!data) {
            let newData = JSON.stringify([itemData]);
            localStorage.setItem('wish_list', newData);
            setWishList([itemData]);
        } else {
            const listArray = JSON.parse(data);
            //check if item is in wishlist and remove it
            if (listArray.some((elem) => elem._id === itemData?._id)) {
                const newArray = listArray.filter((val) => val._id !== itemData?._id);
                localStorage.setItem('wish_list', JSON.stringify(newArray));
                setWishList(newArray);
            } else {
                //add item to wish list
                const newArray = [...listArray, itemData];
                setWishList(newArray);
                localStorage.setItem('wish_list', JSON.stringify(newArray));
            }
        }
    }




    useEffect(() => {
        /** load cart and wish list on rerender */
        const getFromCart = new Promise((resolve, reject) => {
            const data = localStorage.getItem('cart_data');
            if (data) {
                resolve(JSON.parse(data));
            } else {
                reject('cart is empty');
            }
        });

        const getFromWishList = new Promise((resolve, reject) => {
            const data = localStorage.getItem('wish_list');
            if (data) {
                resolve(JSON.parse(data));
            } else {
                reject('wish list is empty');
            }
        });
        (async () => {
            try {
                const cartData = await getFromCart;
                if (!cartData) return
                setCart(cartData);
            } catch (error) {
                console.log({ error });
            }
        })();

        (async () => {
            try {
                const listData = await getFromWishList;
                if (!listData) return
                setWishList(listData);
                console.log(listData);
            } catch (error) {
                console.log({ error });
            }
        })();



    }, []);

    return (
        <CartContext.Provider
            value={{
                cart,
                wishList,
                openCart,
                saveToCart,
                saveToWishList,
                toggleCart
            }}
        >
            {children}
        </CartContext.Provider>
    )
}

export const UseCartList = () => useContext(CartContext);